(() => {
  const root = window.Shopify?.routes?.root || "/";
  let busy = false, activeCheckout = null;
  const request = async (path, body) => {
    const response = await fetch(path, {method: body === undefined ? "GET" : "POST", headers:{"Content-Type":"application/json"}, ...(body === undefined ? {} : {body:JSON.stringify(body)}), signal:AbortSignal.timeout(35000)});
    const data = await response.json().catch(()=>({}));
    if (!response.ok) throw new Error(data.error || data.description || "Could not prepare your bag. Please try again.");
    return data;
  };
  const readCart = () => request(root + "cart.js");
  const oldPortrait = item => item.properties?._pawnted_portrait_id && item.properties._pawnted_checkout_artwork !== "1";

  async function prepareCart(updates) {
    let cart = await readCart();
    if (updates) {
      if (Object.keys(updates).some(key=>!cart.items.some(item=>item.key===key))) throw new Error("Your bag changed in another tab. Refresh this page before checking out.");
      cart = await request(root + "cart/update.js", {updates});
    }
    const legacy = cart.items.filter(oldPortrait);
    if (!legacy.length) return cart;
    let saved = {};
    try { saved = JSON.parse(localStorage.getItem("pawnted-generator-v2") || "{}"); } catch {}
    if (!saved.visitor) throw new Error("Open your saved portraits in this browser and add them to your bag again so we can attach their artwork.");
    const session = await request("/apps/pawnted/session", {previousVisitor:saved.visitor});
    if (!session.visitor) throw new Error("Please reload your portrait studio and try checkout again.");
    try { localStorage.setItem("pawnted-generator-v2", JSON.stringify({...saved,visitor:session.visitor})); } catch {}
    for (const old of legacy) {
      cart = await readCart();
      const original = cart.items.find(item=>item.key===old.key);
      if (!original) continue;
      if (original.quantity !== old.quantity) throw new Error("Your bag quantity changed. Please try checkout again.");
      // The source-line key makes a lost add response recoverable without
      // doubling quantity. Existing ready items remain separate and untouched.
      let replacement = cart.items.find(item=>item.properties?._pawnted_migrated_from===old.key);
      if (!replacement) {
        const item = await request("/apps/pawnted/cart?" + new URLSearchParams({visitor:session.visitor}), {id:old.properties._pawnted_portrait_id,variantId:String(old.properties._pawnted_base_variant || old.variant_id)});
        const properties = {...old.properties,...item.properties,_pawnted_migrated_from:old.key};
        try { await request(root + "cart/add.js", {items:[{...item,quantity:old.quantity,properties}]}); }
        catch (error) {
          cart = await readCart();
          if (!cart.items.some(line=>line.properties?._pawnted_migrated_from===old.key)) throw error;
        }
        cart = await readCart();
        replacement = cart.items.find(line=>line.properties?._pawnted_migrated_from===old.key);
      }
      if (!replacement || replacement.quantity !== old.quantity || replacement.properties?._pawnted_portrait_id !== old.properties._pawnted_portrait_id || replacement.properties?._pawnted_checkout_artwork !== "1")
        throw new Error("Your artwork is still being attached. Please try checkout again.");
      try { await request(root + "cart/change.js", {id:old.key,quantity:0}); }
      catch (error) { if ((await readCart()).items.some(line=>line.key===old.key)) throw error; }
    }
    cart = await readCart();
    if (cart.items.some(oldPortrait)) throw new Error("Your bag changed. Please try checkout again to attach the remaining artwork.");
    return cart;
  }

  async function checkout(trigger, form) {
    if (busy) return;
    busy = true;
    let status = trigger.closest("[data-cart-drawer]")?.querySelector("[data-checkout-status]") || document.querySelector("[data-checkout-status]");
    if (!status) { status=document.createElement("p");status.className="pw-note";status.dataset.checkoutStatus="";status.setAttribute("role","status");trigger.insertAdjacentElement("afterend",status); }
    status.hidden=true;status.textContent="";
    const original = trigger.textContent;
    activeCheckout={trigger,original};
    trigger.textContent="Opening checkout…";trigger.setAttribute("aria-disabled","true");
    const controls = form ? [...form.querySelectorAll("button,input")] : [];
    const disabled = controls.map(control=>control.disabled);
    const updates = form ? Object.fromEntries([...form.querySelectorAll("[data-cart-line-key]")].map(input=>[input.dataset.cartLineKey,Number(input.value)])) : undefined;
    controls.forEach(control=>{control.disabled=true;});
    try {
      if (updates && Object.values(updates).some(q=>!Number.isInteger(q) || q<0 || q>10)) throw new Error("Choose a quantity between 0 and 10.");
      const cart = await prepareCart(updates);
      window.location.assign(root + (cart.items.length ? "checkout" : "cart"));
    } catch (error) {
      status.hidden=false;
      status.textContent=error.message || "Could not prepare checkout. Please try again.";
      trigger.textContent=original;trigger.removeAttribute("aria-disabled");
      controls.forEach((control,index)=>{control.disabled=disabled[index];});busy=false;activeCheckout=null;
    }
  }
  document.addEventListener("click", event=>{
    const link=event.target.closest("a[href]");
    if (!link || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target=new URL(link.href,location.href);
    if(target.origin!==location.origin || target.pathname!==root+"checkout")return;
    event.preventDefault();void checkout(link);
  });
  document.querySelector("form#cart")?.addEventListener("submit", event=>{
    if(event.submitter?.name!=="checkout")return;
    event.preventDefault();void checkout(event.submitter,event.currentTarget);
  });
  window.addEventListener?.("pageshow",event=>{
    if(!event.persisted)return;
    busy=false;
    if(activeCheckout){activeCheckout.trigger.textContent=activeCheckout.original;activeCheckout.trigger.removeAttribute("aria-disabled");activeCheckout=null;}
  });
  window.PawntedCheckout={prepareCart,checkout};
})();
